import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/config";

export const API_BASE_URL = API.replace(/\/api$/, "");
export const api = axios.create({ baseURL: API, withCredentials: true });

export function useAdminLiveFeed() {
  const [events, setEvents] = useState([]);
  useEffect(() => {
    const wsUrl = API.replace(/^http/, "ws") + "/ws/notifications";
    let ws;
    let reconnectTimer;
    let pingTimer;
    const connect = async () => {
      try {
        const r = await api.get("/auth/ws-token");
        ws = new WebSocket(`${wsUrl}?token=${encodeURIComponent(r.data.token)}`);
        ws.onopen = () => { pingTimer = setInterval(() => { try { ws.send("ping"); } catch { /* closed */ } }, 25000); };
        ws.onmessage = (evt) => {
          if (evt.data === "pong") return;
          try {
            const msg = JSON.parse(evt.data);
            if (msg.type === "admin_notification") {
              setEvents((prev) => [{ ...msg, _id: Math.random().toString(36).slice(2) }, ...prev].slice(0, 50));
              toast.message(msg.title, { description: msg.message });
            }
          } catch { /* ignore */ }
        };
        ws.onclose = () => { clearInterval(pingTimer); reconnectTimer = setTimeout(connect, 5000); };
        ws.onerror = () => { try { ws.close(); } catch { /* ignore */ } };
      } catch { reconnectTimer = setTimeout(connect, 10000); }
    };
    connect();
    return () => { clearInterval(pingTimer); clearTimeout(reconnectTimer); if (ws) { try { ws.close(); } catch { /* ignore */ } } };
  }, []);
  return events;
}
